import { aggregatorGetters } from './routines'

export default {
  [aggregatorGetters.COMPANY_OPPORTUNITIES]: state => state.companyOpportunities?.opportunities,
  [aggregatorGetters.AGGREGATOR_OPPORTUNITY_ID]: state => state.aggregatorOpportunityId,
  [aggregatorGetters.IS_ILO_FORM_SUBMITTED]: state => state.isILOFormSubmitted
}
